import { useIsConversationPage } from "@/app/[tenantId]/[messengerId]/[hostConfig]/[locale]/lib/client/hooks/useIsConversationPage";
import { useLayoutContext } from "../../lib/client/contexts/LayoutContext";
import { useIsArticlePage } from "../../lib/client/hooks/useIsArticlePage";

export default function FooterClient({ children }: { children: React.ReactNode }) {
  const isConversationPage = useIsConversationPage();
  const isArticlePage = useIsArticlePage();

  const { pageRendered } = useLayoutContext();

  if (isArticlePage || isConversationPage || !pageRendered) {
    return null;
  }

  return <>{children}</>;
}
